import { ApiErrorDiagnostics } from '~/Interfaces';

// Exposed via Access-Control-Expose-Headers by svc-onboarding (qred/svc-onboarding#249).
export const ERROR_ID_HEADER = 'x-qred-error-id';
export const TRACE_ID_HEADER = 'x-amzn-trace-id';
export const REQUEST_ID_HEADER = 'x-amzn-requestid';

// Satisfied by fetch Headers and by AxiosHeaders, whose overloaded get() can also
// return arrays, numbers and booleans. Narrowing to the string case happens in
// readHeader so no caller has to think about it.
export interface ResponseHeaders {
  get(name: string): unknown;
}

export const isResponseHeaders = (value: unknown): value is ResponseHeaders =>
  typeof (value as ResponseHeaders | null | undefined)?.get === 'function';

const readHeader = (
  headers: ResponseHeaders,
  name: string
): string | undefined => {
  const value = headers.get(name);

  return typeof value === 'string' && value ? value : undefined;
};

export const extractErrorDiagnostics = (
  headers: ResponseHeaders
): Omit<ApiErrorDiagnostics, 'capturedAt'> | undefined => {
  const errorId = readHeader(headers, ERROR_ID_HEADER);

  if (!errorId) {
    return undefined;
  }

  return {
    errorId,
    traceId: readHeader(headers, TRACE_ID_HEADER),
    requestId: readHeader(headers, REQUEST_ID_HEADER),
  };
};
